export enum ReportType {
  NAV_SUMMARY = "NAV Summary",
  HOLDINGS_DETAIL = "Holdings Detail",
  COMBINED_REPORT = "Oversight Summary Report",
}

export interface Report {
  reportId: string;
  fundId: string;
  periodId: string;
  periodName: string;
  name: string;
  type: ReportType;
  format: "PDF" | "Excel" | "CSV";
  createdAt: string;
  createdBy: string;
  fileSize: number; // in bytes
  downloadUrl?: string;
}

export interface ReportGenerationOptions {
  includeNAVSummary: boolean;
  includeHoldings: boolean;
  includePerformance: boolean;
  format: "PDF" | "Excel" | "CSV";
}

// Real data interfaces based on actual API structure
export interface NAVSummaryData {
  totalNAV: number;
  currency: string;
  totalHoldings: number;
  confirmedHoldings: number;
  unconfirmedHoldings: number;
  asOfDate: string;
}

export interface ReportPreviewData {
  fundName: string;
  fundKey: string;
  reportingPeriod: string;
  asOfDate: string;
  navSummary?: NAVSummaryData;
  totalTransactions?: number;
  totalHoldings?: number;
  lastTransactionDate?: string;
  // Exception summary for report preview
  exceptionSummary?: ExceptionSummary;
  exceptionDetails?: ExceptionDetailRow[];
}

export interface ExceptionSummary {
  rulesRun: number;
  passes: number;
  failures: number;
  failuresOpen: number;
  failuresResolved: number;
}

export interface ExceptionDetailRow {
  rule: string;
  description: string;
  result?: string | number;
  expected?: string | number;
  tolerance?: string | number;
  assignedTo?: string;
  checkedBy?: string;
  notes?: string;
  status?: string;
}
